import React from 'react';
import { GenericSkeleton } from '@landr/maestro';
import { Heading } from './styled';

const Title = ({
    content,
    isLoading,
    isVertical,
}: {
    content?: string;
    isLoading: boolean;
    isVertical: boolean;
}) => {
    const size = isVertical ? 'xxxl' : 'jb';
    const height = isVertical ? '32px' : '38px';

    if (isLoading) {
        return (
            <GenericSkeleton
                width="225px"
                height={height}
                mb={isVertical ? 27 : 30}
            />
        );
    }

    return (
        <Heading size={size} nbOfLines={2}>
            {content}
        </Heading>
    );
};

export default Title;
